'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DelimiterWrapper = require('./DelimiterWrapper');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DelimiterWrapper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }